<template>
    <div class="section-content">   
      <h2>Mentor duties</h2>
      
      <p>Having decided the Dialogue is the right route for the individual you are mentoring, arrange two meetings where the claimant can practise with you; these can be online to replicate more closely the real event. Explain you will be interjecting frequently so they get used to the feeling of a dialogue rather than a monologue. Since this is not a job interview, you may, in the role of mentor, occasionally be self-referential. ‘Yes that aspect is particularly challenging in this discipline, isn’t it?’; ‘I once took the opposite approach on this’ etc, but even in practice run you should take care not to dominate the discussion.</p>

      <p>You might find during the practice that you ‘lead’ the claimant in their responses, helping them to articulate concepts such as their leadership style, or pedagogical approaches (this will very much depend on their experience). In the actual dialogue they will be expected to articulate clearly why and how they decide on leadership activities, using appropriate vocabulary to communicate the fine detail of activities, and with some brief reference to relevant research, as this indicates an evidence-informed approach to their work.</p>

      <p>Your meetings should be around an hour long in total, to allow time to discuss any ‘gaps’ or communication issues at the end. Make clear though that you do not have unlimited time; there need to be boundaries around your availability and it is the responsibility of the claimant to use your time well.</p>

      <h3>Reflective activity</h3>

      <p>Map these questions to the Dimensions of Practice for SFHEA. Add some more questions and interjections to this list, using the Dimensions of Practice for D3 as a guide:</p>
    </div>

    <div class="section-content-icons"> 

      <div class="">
        <div class="section-content-icon ">
 <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="15" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <circle cx="16" cy="24.5" r="1.5"/>
              <path d="M12.91,7.79c2.79-1.24,6.41-1.09,7.65,.91s.38,4.32-1.74,6.12-2.82,2.77-2.82,4.18" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
        </div>
        <div class="section-content-text">
            <p>Could you speak a little more about which research or pedagogies underpins your approach to teaching, and to leadership?</p>
        </div>
    </div>
  
    <div class="">
          <div class="section-content-icon">
 <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="15" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <circle cx="16" cy="24.5" r="1.5"/>
              <path d="M12.91,7.79c2.79-1.24,6.41-1.09,7.65,.91s.38,4.32-1.74,6.12-2.82,2.77-2.82,4.18" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
          </div>
          <div class="section-content-text">
            <p>What steps do you take to ensure the co-ordination is working effectively for all staff, not just the vocal ones? How does this fit with your approach to equality diversity and inclusivity more generally?</p>
          </div>
    </div>
  </div>
    <div class="section-content-icons"> 

      <div class=" ">
        <div class="section-content-icon">   
 <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="15" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <circle cx="16" cy="24.5" r="1.5"/>
              <path d="M12.91,7.79c2.79-1.24,6.41-1.09,7.65,.91s.38,4.32-1.74,6.12-2.82,2.77-2.82,4.18" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
        </div>
        <div class="section-content-text">
            <p>How do you promote participation in HE more widely, either directly or indirectly? What’s your view on Widening Participation, and why?</p>
        </div>
    </div>
  
    <div class=" ">
          <div class="section-content-icon">
           
 <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="15" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <circle cx="16" cy="24.5" r="1.5"/>
              <path d="M12.91,7.79c2.79-1.24,6.41-1.09,7.65,.91s.38,4.32-1.74,6.12-2.82,2.77-2.82,4.18" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
          </div>
          <div class="section-content-text">
            <p>Was it difficult persuading staff to change their existing approach to teaching and learning? Tell me about the challenges and how, and to what extent you met them?</p>
          </div>
    </div>
  </div>

    <div class="section-content-icons"> 

      <div class=" ">
        <div class="section-content-icon">   
 <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="15" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <circle cx="16" cy="24.5" r="1.5"/>
              <path d="M12.91,7.79c2.79-1.24,6.41-1.09,7.65,.91s.38,4.32-1.74,6.12-2.82,2.77-2.82,4.18" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
        </div>
        <div class="section-content-text">
            <p>How would you describe your leadership style when you set up and ran the team?</p>
        </div>
    </div>
  
    <div class=" ">
          <div class="section-content-icon">
           
 <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="15" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <circle cx="16" cy="24.5" r="1.5"/>
              <path d="M12.91,7.79c2.79-1.24,6.41-1.09,7.65,.91s.38,4.32-1.74,6.12-2.82,2.77-2.82,4.18" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
          </div>
          <div class="section-content-text">
            <p>Have you undertaken any CPD which has directly influenced how you lead and teach?</p>
          </div>
    </div>
  </div>


  




  <div class="section-content wysiwyg-hide">   
    <div class="section-question  background-colour">
        <div class="question">   
          <p><b>Map these questions to the Dimensions of Practice for SFHEA. Add some more questions and interjections to this list, using the Dimensions of Practice for D3 as a guide. </b></p>
        </div>  
        <WYSIWYGTwo :isEditingTwo="isEditingTwo" @submitQuestionTwo = "saveTextTwo" />
    </div>
  </div>
  


</template>

<script>

import { ref } from '@vue/reactivity'
import { useQuasar } from 'quasar'
import WYSIWYGTwo from '../WYSIWYGTwo.vue'

export default {
  components: {WYSIWYGTwo},
  setup() {
  const isEditingTwo = ref(true) 

  const sessionMemory = useQuasar()

   const saveTextTwo = (save) => {
      sessionMemory.localStorage.set('questionTwo', save)
      isEditingTwo.value = !isEditingTwo.value
      console.log(sessionMemory.localStorage.has('questionTwo'))  
   }

    return { isEditingTwo, saveTextTwo, sessionMemory }
  }
  }

</script>

<style>

</style>